import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { AUTOMATION_LOADS } from './actions';
import { BULK_CAPACITY_MATCH_JOB_TABLE, BulkCapacityMatchJobTable } from 'cargo-chief-commons';

// The push carries no jobTasks (one row per CSV line would be an unbounded frame), so the
// expandable row detail only ever exists on rows that came from the list endpoint. Keep whatever
// the existing row already holds and overwrite only what the push actually knows.
const mergeRowDetail = (
	existingJob: BulkCapacityMatchJobTable,
	pushedRow: BulkCapacityMatchJobTable
): BulkCapacityMatchJobTable => ({
	...pushedRow,
	rowDescription: existingJob.rowDescription,
	tasksCompleted: existingJob.tasksCompleted,
});

export const reducers = createReducer(
	initialState,
	on(AUTOMATION_LOADS.LOADS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(AUTOMATION_LOADS.LOADS_LIST.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		loadsList: BULK_CAPACITY_MATCH_JOB_TABLE(action.data, state.usersList),
		total: action.totalElements,
	})),
	on(AUTOMATION_LOADS.LOADS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
	})),

	on(AUTOMATION_LOADS.CARRIER_OFFER_STATUS.SET_CARRIERS_OFFER_STATUS, (state, action) => ({
		...state,
		currentCarrierOffersStatus: action.data,
	})),

	on(AUTOMATION_LOADS.CARRIER_OFFER_STATUS.SET_BA_ACCOUNT_SETTING_DISABLED, (state, action) => ({
		...state,
		baAccountSettingDisabled: action.setting,
	})),

	on(AUTOMATION_LOADS.USERS_LIST.SET, (state, action) => ({
		...state,
		usersList: action.usersList,
	})),

	on(AUTOMATION_LOADS.IMPORT_JOB.ADD, (state, action) => {
		const { bulkCapacityMatchJob } = action;
		const [pushedRow] = BULK_CAPACITY_MATCH_JOB_TABLE(
			[bulkCapacityMatchJob],
			state.usersList
		);
		if (!pushedRow) {
			return state;
		}
		// SQS redelivers. A replayed ADD must not duplicate the row, bump the total, drag the row
		// back to the top of the list, or drop the detail the list endpoint supplied.
		if (state.loadsList.some((job) => job.id === bulkCapacityMatchJob.id)) {
			return {
				...state,
				loadsList: state.loadsList.map((existingJob) =>
					existingJob.id === bulkCapacityMatchJob.id
						? mergeRowDetail(existingJob, pushedRow)
						: existingJob
				),
			};
		}
		return {
			...state,
			loadsList: [pushedRow, ...state.loadsList],
			total: state.total + 1,
		};
	}),

	on(AUTOMATION_LOADS.IMPORT_JOB.UPDATE, (state, action) => {
		const { bulkCapacityMatchJob } = action;
		const [pushedRow] = BULK_CAPACITY_MATCH_JOB_TABLE(
			[bulkCapacityMatchJob],
			state.usersList
		);
		if (!pushedRow) {
			return state;
		}
		return {
			...state,
			loadsList: state.loadsList.map((existingJob) =>
				existingJob.id === bulkCapacityMatchJob.id
					? mergeRowDetail(existingJob, pushedRow)
					: existingJob
			),
		};
	})
);
